export default __webpack_public_path__ + "static/media/cage-circle.74944866.svg";